import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClickService} from '../../../core/services/click.service';
import {EscapeKeyService} from '../../../core/services/escape-key.service';
import {BaseDrawerComponent} from '../_base-drawer/base-drawer.component';
import {NgStyle} from '@angular/common';
import {TileHistoryViewportBufferComponent} from '../tile-history-viewport-buffer/tile-history-viewport-buffer.component';
import {SpinnerComponent} from '../spinner/spinner.component';

@Component({
    selector: 'motn-drawer-gap-from-top',
    templateUrl: './drawer-gap-from-top.component.html',
    styleUrls: ['./drawer-gap-from-top.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgStyle,
        TileHistoryViewportBufferComponent,
        SpinnerComponent,
    ]
})
export class DrawerGapFromTopComponent extends BaseDrawerComponent implements OnInit, OnDestroy {
  @Input() addToTopGap: number = 0;
  @Input() loading: boolean = false;

  cssHeight: string;
  cssMarginTop: string;


  constructor(
    protected clickService: ClickService,
    protected escapeKeyService: EscapeKeyService,
  ) {
    super(clickService, escapeKeyService);
  }


  protected onInit() {
    const gapFromTopPx = +this.bodyStyle.getPropertyValue('--motn-drawer-gap-top').replace('px', '');

    this.cssMarginTop = (gapFromTopPx + this.addToTopGap) + 'px';
    this.cssHeight = `calc(100% - ${this.cssMarginTop})`;
  }
}
